import { Component, EventEmitter, Output, Input, ViewChild, ElementRef } from '@angular/core';
import {Common} from '../../shared/common';
import {ShortVoter} from '../../models/ShortVoter';

@Component({
  selector: 'resend-invite-popup',
  templateUrl: './resend-invite-popup.component.html',
  styleUrls: ['./resend-invite-popup.component.less', '../../shared/common.less']
})
export class ResendInvitePopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Output() sendInviteEvent = new EventEmitter<string>();
  @Input() contactToInvite: string = "";
  @ViewChild('messageTextarea') messageTextarea?: ElementRef<HTMLTextAreaElement>;
  
  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  onSendInvite() {
    const message = this.messageTextarea?.nativeElement?.value || '';
    this.sendInviteEvent.emit(message);
  }

  ngOnInit() {}

  /**
   * Valide le format d'une adresse email
   */
  isValidEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

}
